import { css } from '@emotion/react';

import { theme } from '../theme';

const styles = {
  priceListStyling: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: ${theme.spacing.sm};
    gap: ${theme.spacing.sm};

    > p {
      font-size: ${theme.fontSize.sm};
      margin: 0;
    }
  `,
  price: css`
    white-space: nowrap;
    margin-bottom: 0;
  `,
  container: css`
    display: flex;
    gap: ${theme.spacing.sm};
    justify-content: space-between;
  `,
  originalPoints: (align: 'left' | 'right') => css`
    font-weight: ${theme.fontWeight.normal};
    margin-left: ${align === 'left' ? theme.spacing.sm : 0};
    margin-right: ${align === 'right' ? theme.spacing.sm : 0};
    order: ${align === 'right' ? -1 : 1};
  `,
  lineThrough: css`
    text-decoration: line-through;
  `,
};

export const Item = ({
  label,
  price,
  discountedPoints,
}: {
  label: string | undefined;
  discountedPoints?: string;
  price: string;
}) => {
  const hasDiscount = discountedPoints !== undefined;
  return (
    <div css={styles.priceListStyling}>
      {label ? <p>{label}</p> : null}
      <div css={styles.container}>
        {hasDiscount ? (
          <>
            <p css={styles.price}>{discountedPoints}</p>
            <p css={hasDiscount ? styles.lineThrough : styles.price}>{price}</p>
          </>
        ) : (
          <p css={styles.price}>{price}</p>
        )}
      </div>
    </div>
  );
};
